import { render, staticRenderFns } from "./NivelesUsuarios.vue?vue&type=template&id=0c41f840&scoped=true"
import script from "./NivelesUsuarios.vue?vue&type=script&lang=js"
export * from "./NivelesUsuarios.vue?vue&type=script&lang=js"
import style0 from "./NivelesUsuarios.vue?vue&type=style&index=0&id=0c41f840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c41f840",
  null
  
)

export default component.exports